import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import StudentSidebar from "./studentSidebar";
import StudentHeader from "./StudentHeader";

const StudentPanel = () => {
  // 1. Initialize as FALSE so it is collapsed by default
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [activePath, setActivePath] = useState("");
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Theme detection
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const shouldBeDark = savedTheme === "dark";
    setIsDarkMode(shouldBeDark);

    if (shouldBeDark) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
  }, []);

  useEffect(() => {
    const handleThemeChange = () => {
      const savedTheme = localStorage.getItem("theme");
      const shouldBeDark = savedTheme === "dark";
      setIsDarkMode(shouldBeDark);

      if (shouldBeDark) {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    };

    window.addEventListener("themeChanged", handleThemeChange);
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
    };
  }, []);

  // Set active path
  useEffect(() => {
    const path = location.pathname;
    setActivePath(path);
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  }, [location.pathname]);

  // --- FIX STARTS HERE ---
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);

      // Only auto-close if we switch to mobile.
      // REMOVED the 'else' block that forced it to open on desktop.
      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Check initial size

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // --- FIX ENDS HERE ---

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  // Excluded pages logic
  const isCategorySelectionPage = location.pathname === "/student-panel/category-selection";
  const isCourseSelectionPage = location.pathname === "/student-panel/course-selection";
  const isinstructorSelectionPage = location.pathname === "/student-panel/instructor-selection";
  const isCourseDetailsSelectionPage = location.pathname === "/student-panel/selected-course-details";
  const isCourseAllSetPage = location.pathname === "/student-panel/course-all-set";
  const isStartLearningPage = location.pathname === "/student-panel/start-learning";
  const isAssignmentPage = location.pathname.includes("/student-panel/assignment-student/");

  const isExcludedPage =
    isCategorySelectionPage ||
    isCourseSelectionPage ||
    isinstructorSelectionPage ||
    isCourseDetailsSelectionPage ||
    isCourseAllSetPage ||
    isStartLearningPage ||
    isAssignmentPage;

  // --- LOGIC UPDATE ---
  // Removed "&& isSidebarOpen". 
  // We want the sidebar component to RENDER (showing icons) even if closed.
  const showSidebar = !isMobile && !isExcludedPage; 
  
  const showHeader = !isExcludedPage;
  const showBottomNav = isMobile && !isExcludedPage;

  return (
    <div
      style={{
        backgroundColor: isDarkMode ? "#111827" : "#ffffff",
        minHeight: "100vh",
        paddingBottom: showBottomNav ? "60px" : "0",
      }}
    >
      {showHeader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 50,
            width: "100%",
          }}
        >
          <StudentHeader
            onToggleSidebar={toggleSidebar}
            isSidebarOpen={isSidebarOpen}
          />
        </div>
      )}

      <div style={{ display: "flex", position: "relative" }}>
        {showSidebar && (
          <div
            style={{
              position: "fixed",
              left: 0,
              top: "64px",
              height: "calc(100vh - 64px)",
              zIndex: 40,
              // If Open: 16rem (240px), If Closed: 4rem (64px)
              width: isSidebarOpen ? "240px" : "64px", 
              transition: "width 0.3s ease",
              overflow: "hidden",
            }}
          >
            <StudentSidebar
              isOpen={isSidebarOpen}
              activePath={activePath}
              onPathChange={setActivePath}
            />
          </div>
        )}

        <div
          style={{
            // Adjust margin based on whether sidebar is expanded or collapsed
            marginLeft: showSidebar ? (isSidebarOpen ? "240px" : "64px") : "0",
            marginTop: showHeader ? "64px" : "0",
            padding: "0",
            flexGrow: 1,
            transition: "margin-left 0.3s ease",
            backgroundColor: isDarkMode ? "#111827" : "#ffffff",
            minHeight: "100vh",
            width: "100%",
          }}
        >
          <Outlet />
        </div>
      </div>

      {showBottomNav && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1000,
          }}
        >
          <StudentSidebar
            isOpen={false}
            activePath={activePath}
            onPathChange={setActivePath}
          />
        </div>
      )}
    </div>
  );
};

export default StudentPanel;